<template>
  <div class="fit-container password-keyboard-page">
    <div class="pwd-full-page-bg"></div>
    <div class="pwd-full-page-container">
      <div class="pwd-container">
        <div class="main-title" v-if="title">{{title}}</div>
        <div class="sub-title" v-if="subTitle">{{subTitle}}</div>
        <slot></slot>
        <div class="pwd-input">
          <FitPassword title :length="pwdLength" :value="value" @click="eClick" @filled="filled"></FitPassword>
        </div>
      </div>
      <slot name="content"></slot>
      <FitKeyboard :hidden="keyboardHidden" @bind-tap="onBindTap"></FitKeyboard>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { FitPassword, FitKeyboard } from '@tencent/wphk-ui';

export default Vue.extend({
  name: 'fitVerifyPwdPage',
  components: {
    FitPassword,
    FitKeyboard,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    pwdLength: {
      type: Number,
      required: true,
    },
    pin: {
      type: Array,
      required: false,
      default: () => [],
    },
    keyboardHidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      output: this.pin,
    };
  },
  computed: {
    value() {
      return this.output.join('');
    },
  },
  methods: {
    eClick() {
      this.$emit('click');
    },
    filled(value) {
      this.$emit('filled', value);
    },
    onBindTap(e) {
      const { value } = e.detail;
      if (value) {
        if (value === 'DEL') {
          this.output.pop();
        } else {
          if (this.output.length < this.pwdLength) {
            this.output.push(value);
            this.$emit('typing');
          }
        }
      }
    },
  },
  watch: {
    pin() {
      this.output = this.pin;
    },
  },
});
</script>
